module.exports = __webpack_public_path__ + "static/media/b12.312ac19f.jpg";